import { DateRangePicker } from "../../../client/components/DateRangePicker";
import { AccountGroupFilter } from "../../../trading-accounts/AccountGroupFilter";
import StrategyMultiSelect from "../../../client/components/StrategyMultiSelect";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";

export default function PropFirmFiltersWidget() {
  const {
    dateRange, setDateRange,
    accountFilter, setAccountFilter,
    strategyIds, setStrategyIds,
    accounts, groups, strategies,
  } = usePfmData();

  return (
    <div className="flex flex-wrap items-center gap-2 px-3 h-full">
      <DateRangePicker value={dateRange} onChange={setDateRange} />
      <AccountGroupFilter
        accounts={accounts}
        groups={groups}
        value={accountFilter}
        onChange={setAccountFilter}
        className="w-[180px]"
      />
      {strategies.length > 0 && (
        <StrategyMultiSelect
          strategies={strategies}
          selectedIds={strategyIds}
          onChange={setStrategyIds}
          className="min-w-[160px]"
        />
      )}
    </div>
  );
}
